/*
 * @Description: 首页相关接口 Api
 * @Author:WangLiXin
 * @Date: 2022-111-17 16:26:14
 * @LastEditors: PF
 * @LastEditTime: 2024-06-19 10:32:55
 * @LastEditors: PF
 * @LastEditTime: 2023-01-17 10:11:30
 * @FilePath: \VUE3\src\api\home.js

/** ---------- 常规/事务 通用 开始 ---------- */
import request from './request'
// 审批办理 审批办理角标
export function myshenpibanlicount (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/myshenpibanlicount',
    method: 'post',
    data
  })
}
/** ---------- 通用 申请 开始 ---------- */
// 按分组查询审批表单
export function banGongShenPiFenZu (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpi/faqibiaodan',
    method: 'post',
    data
  })
}
/**
 * 审批申请 添加
 * @param {[spid] 审批ID [zt] 状态:0-草稿、1-提交 [spbds] 审批表单 [spbds.bdid] 表单ID [spbds.lx] 表单类型 [spbds.inputVal] 表单值(字符串) [spbds.inputArr] 表单值(数组)} data
 * @returns
 */
export function bangongshenpishenqing (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing',
    method: 'post',
    data
  })
}
// 审批申请 表单组件列表查询
export function biaodanlist (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing/biaodanlist',
    method: 'post',
    data
  })
}
// 审批申请 查看数据
export function biaodanshuju (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing/biaodanshuju',
    method: 'post',
    data
  })
}
// 审批申请 查询我申请的审批数量
export function shenqingshenpinumber (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing/shenqingshenpinumber',
    method: 'post',
    data
  })
}
// 审批申请 查询我申请的审批详情
export function shenqingshenpidetail (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing/shenqingshenpidetail',
    method: 'post',
    data
  })
}
// 审批申请 查询我申请的审批数组
export function shenqingshenpilist (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpishenqing/shenqingshenpilist',
    method: 'post',
    data
  })
}
/** ---------- 通用 申请 结束 ---------- */

/** ---------- 通用 审批/办理 开始 ---------- */
// 审批/办理 审核列表
export function myshenpibanli (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/myshenpibanli',
    method: 'post',
    data
  })
}
// 审批/办理 抄送列表
export function mychaosong (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/mychaosong',
    method: 'post',
    data
  })
}
// 审批/办理 详情
export function biaodanshenpiliucheng (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/biaodanshenpiliucheng',
    method: 'post',
    data
  })
}
// 审批/办理 同意/拒绝
export function liuzhuanbuzhou (data) {
  return request({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/liuzhuanbuzhou',
    method: 'post',
    data
  })
}

/** ---------- 通用 审批/办理 结束 ---------- */

/** ---------- 常规/事务 通用 结束 ---------- */
/** ------------教职工信息开始------------**/
// 教职工信息
export function getjiaozhigondata (query) {
  return request({
    url: '/api/v2/account/getCurrentUserJzg',
    method: 'POST',
    params: query
  })
}
/** ------------教职工信息结束------------**/
/** ------------待办事项开始------------**/
export function getdaibanshixiang (data) {
  return request({
    url: '/api/v2/bangong/bangongdaibanshixiang/myshenpibanli',
    method: 'POST',
    data
  })
}
/** ------------待办事项结束------------**/
/** ---------- 常规/事务 通用 结束 ---------- */

/** ---------- 常规/事务 教师 开始 ---------- */

// 教学设计 当前教师 管理列表
export function jiaoshilist (query) {
  return request({
    url: '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian/?xqid=' + query.xqid + '&zc=' + query.zc,
    method: 'POST'
  })
}

/** ---------- 常规/事务 教师 结束 ---------- */

/** ---------- 常规/事务 班主任 开始 ---------- */

// 查询当前登录人是班主任的班级
export function banzhuren (data) {
  return request({
    url: '/api/v2/pdp/banji/banzhuren',
    method: 'POST',
    data
  })
}
// 查询班级学生 Api
export function banjixuesheng (data) {
  return request({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    method: 'POST',
    data
  })
}
// 查询班级的拆班课
export function chaibanke (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/kecheng',
    method: 'POST',
    data
  })
}
// 查询班级的拆班课分组
export function chaibankefenzu (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/list',
    method: 'POST',
    data
  })
}
// 查询拆班学生 Api
export function xueshenglist (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/xueshenglist',
    method: 'POST',
    data
  })
}
// 添加拆班学生
export function xueshengAdd (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/xuesheng',
    method: 'POST',
    data
  })
}
// 删除拆班学生 Api
export function xueshengDelete (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/xuesheng',
    method: 'DELETE',
    data
  })
}
// 未分配学生
export function weifenpeixuesheng (data) {
  return request({
    url: '/api/v2/jiaowu/chaibanke/weifenpeixuesheng',
    method: 'POST',
    data
  })
}
// 学籍异动
export function xueshengxuejiyidongjilubanzhuren (query) {
  return request({
    url: '/api/v2/jiaowu/xueshengxuejiyidongjilu/banzhuren',
    method: 'POST',
    params: query
  })
}

/** ---------- 常规/事务 班主任 结束 ---------- */
/** ---------- 常规/事务 学生请假 开始 ---------- */
// 班主任代申请，学生请假记录
export function xveshengqingjailist (query) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/banzhurenpagelist',
    method: 'POST',
    params: query
  })
}
// 班主任代申请，学生请假记录教务
export function xveshengqingjailistjw (query) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/pagelist',
    method: 'POST',
    params: query
  })
}

// 查询当前登录人是班主任的班级树形
export function chaxvnbanjitree (data) {
  return request({
    url: '/api/v2/pdp/banji/tree',
    method: 'POST',
    data
  })
}
// // 查询当前登录人是班主任的班级
// export function chaxvnbanji (data) {
//   return request({
//     url: '/api/v2/pdp/banji/banzhuren',
//     method: 'POST',
//     data
//   })
// }
// 查询班级学生
export function getbanjixvesheng (data) {
  return request({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    method: 'POST',
    data
  })
}
// 查询当前登录人是班主任的班级
export function chaxvnbanji (data) {
  return request({
    url: '/api/v2/pdp/banji/banzhuren',
    method: 'POST',
    data
  })
}

// 添加学生请假
export function xueshengqingjiaAdd (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/banzhuren',
    method: 'POST',
    data
  })
}
// 添加学生请假
export function xueshengqingjiaAddjw (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/jiaowu',
    method: 'POST',
    data
  })
}
// 生效学生请假 Api
export function shengxiaobtn (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/shengxiao',
    method: 'POST',
    data
  })
}
// 销毁请假 Api
export function xiaohuibtn (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/xiaojia',
    method: 'POST',
    data
  })
}
// 删除 Api
export function shanchubtn (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu',
    method: 'DELETE',
    data
  })
}
// 学生详情
export function getqingjiaInfo (query) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/' + query.id,
    method: 'POST'
  })
}
// 修改
export function qingjiaEdit (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu',
    method: 'PATCH',
    data
  })
}
// 提交请假
export function tijiaoqingjia (data) {
  return request({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/tijiao',
    method: 'POST',
    data
  })
}

/** ---------- 常规/事务 学生请假 结束 ---------- */
/** ---------- 常规/事务 学生考勤 开始 ---------- */
export function xvekaoqinlist (query) {
  return request({
    url: '/api/v2/jiaowu/xueshengkaoqin/xueshengkaoqin',
    method: 'POST',
    params: query
  })
}
/** ---------- 常规/事务 学生考勤 结束 ---------- */
/** ---------- 常规/事务 教师听课记录 结束 ---------- */
// 听课记录分页
export function gettingkejlu (query) {
  return request({
    url: '/api/v2/jiaowu/tingkejilu/pagelist',
    method: 'POST',
    params: query
  })
}
// 听课记录模板
export function mobandata (query) {
  return request({
    url: '/api/v2/jiaowu/muban/zujianlist',
    method: 'POST',
    params: query
  })
}
// 查询单个课表详情
export function kebiaoxiangqing (data) {
  return request({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/detail',
    method: 'POST',
    data
  })
}
// 添加听课记录
export function addtingkejilu (data) {
  return request({
    url: '/api/v2/jiaowu/tingkejilu',
    method: 'POST',
    data
  })
}
// 听课记录详情
export function getjiluInfo (query) {
  return request({
    url: '/api/v2/jiaowu/tingkejilu/' + query.id,
    method: 'POST'
  })
}
// 修改
export function jiluEdit (data) {
  return request({
    url: '/api/v2/jiaowu/tingkejilu',
    method: 'PATCH',
    data
  })
}
// 删除听课记录 Api
export function dletejilu (data) {
  return request({
    url: '/api/v2/jiaowu/tingkejilu',
    method: 'DELETE',
    data
  })
}
/** ---------- 常规/事务 教师听课了模板 结束 ---------- */

/** ---------- 校历日程 开始 ---------- */
export function querymyricheng (data) {
  return request({
    url: '/api/v2/bangong/richeng/myricheng',
    method: 'POST',
    data
  })
}
export function querycurrentzhouci () {
  return request({
    url: '/api/v2/jiaowu/jiaowuxiaoli/currentzhouci',
    method: 'POST'
  })
}
/** ---------- 校历日程 结束 ---------- */

/** ---------- 我的成就 开始 ---------- */
export function mychengjiu () {
  return request({
    url: '/api/v2/pdp/jiaozhigongchengjiu/mychengjiu',
    method: 'POST'
  })
}
/** ---------- 我的成就 结束 ---------- */
